import { FormattedMessage } from "react-intl";

import { RanaHeading } from "@nens/ranalib";

import { BasePage } from "@/components/base-page";
import { TenantNewProject } from "@/features/project";

export function TenantNewProjectPage() {
  return (
    <BasePage
      activeSidebarButton="projects"
      pageSubTitle={<FormattedMessage id="page_title.new_project" defaultMessage="New project" />}
    >
      <RanaHeading type="h1" addDot>
        <FormattedMessage id="heading.create-new-project" defaultMessage="Create new project" />
      </RanaHeading>
      <TenantNewProject />
    </BasePage>
  );
}
